const BASE_URL = "https://posalji-racun.com";

const config = {
  BASE_URL,
  SUBMIT_PATH: `${BASE_URL}/public/participant/create`,
  CHECK_PATH: `${BASE_URL}/public/participant/checkBillCode`
};

export default config;
